import React from "react"
import Autocomplete from "../../../../components/Autocomplete"
import connect from "./connect"
import {Wrapper, Container, HeaderContainer, SeeAllLinkContainer, HeaderText} from "../components"
import {SuggestionItem} from "../../../../models/autocomplete"
import {SEARCH_DATA_GA, HEADER_AUTOCOMPLETE_SEE_ALL_RESULTS_DATA_GA} from "../../../../config/constants"
import type {AutoComplete as AutoCompleteType} from "../../../../models/text"

export type SimpleAutocompleteProps = {
    getConnectedPlpUrl: (suggestion: string, siteUrl: string) => string
    term: string
    numFound: number
    suggestions: SuggestionItem[] | null
    isLoading: boolean
    text: AutoCompleteType
    siteUrl: string
}

type HeaderProps = {
    text: AutoCompleteType
}

const Header = ({text}: HeaderProps) => (
    <HeaderContainer data-testid="header-simple-autocomplete-title" sx={{display: {md: "none", xs: "block"}}}>
        <HeaderText variant="subtitle2">{text.headerText}</HeaderText>
    </HeaderContainer>
)
const Content = ({getConnectedPlpUrl, term, numFound, text, siteUrl}: SimpleAutocompleteProps) => {
    const {searchLinktext} = text

    return (
        <Wrapper data-testid="recents-body">
            {numFound > 0 && (
                <>
                    <Autocomplete isSimple />
                    <SeeAllLinkContainer sx={{display: {md: "none", xs: "block"}}}>
                        <a
                            data-testid="header-simple-autocomplete-see-all-results-link"
                            data-ga-v1={SEARCH_DATA_GA}
                            data-ga-v3={HEADER_AUTOCOMPLETE_SEE_ALL_RESULTS_DATA_GA}
                            href={getConnectedPlpUrl(term, siteUrl)}
                        >
                            {searchLinktext}
                        </a>
                    </SeeAllLinkContainer>
                </>
            )}
        </Wrapper>
    )
}

export const SimpleAutocomplete = (props: SimpleAutocompleteProps) => {
    const {numFound} = props
    return numFound > 0 ? (
        <Container data-testid="header-simple-auto-complete" className="simple-autocomplete">
            <Header text={props.text} />
            <Content {...props} />
        </Container>
    ) : null
}

export default connect(SimpleAutocomplete)
